import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../../utils/config-service';
import { Company } from '../../models/company';
import { User } from '../../models/user';

import { Observable } from 'rxjs/Rx';

@Injectable()
export class AdminApiService {
    private adminUrl: string;
    private jsonHeader: HttpHeaders;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.adminUrl = this.configService.getEnv('accountApi');
        this.jsonHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    getCompanies(): Observable<{} | Company[]> {
        let url = this.adminUrl + 'Company ';
        return this.http.get(url)
            .map((result: any) => {
                let json = result;
                return json.map((compJson: any) => new Company(compJson));
            }).catch((error: any) => {
                throw error;
            });
    }

    getCurrentCompany(companyId: string): Observable<{} | Company> {
        let url = this.adminUrl + 'Company/' + companyId;
        return this.http.get(url)
            .map((result: any) => {
                let json = result;
                return new Company(json[0]);
            }).catch((error: any) => {
                throw error;
            });
    }

    createCompany(company: Company): Observable<{} | boolean> {
        let url = this.adminUrl + 'Company';

        return this.http.post(url, JSON.stringify({
            name: company.name,
            maxAllowedUsers: company.maxAllowedUsers || undefined
        }), { headers: this.jsonHeader })
            .map((result: any) => {
                if (result) {
                    return true;
                }
                return false;
            })
            .catch((error: any) => {
                throw error;
            });
    }

    updateCompany(company: Company): Observable<{} | boolean[]> {
        let url = this.adminUrl + 'Company/' + company.id;
        return this.http.put(url, JSON.stringify({
            name: company.name,
            maxAllowedUsers: company.maxAllowedUsers || undefined
        }), { headers: this.jsonHeader })
            .map((result: any) => {
                if (result) {
                    return true;
                }
                return false;
            })
            .catch((error: any) => {
                throw error;
            });
    }

    deleteCompany(companyId: string, deleteToken: string): Observable<{} | boolean> {
        let url = this.adminUrl + 'Company/' + companyId + '/' + deleteToken;
        return this.http.delete(url, { headers: this.jsonHeader })
            .map((result: any) => {
                if (result) {
                    return true;
                }
                return false;
            })
            .catch((error: any) => {
                throw error;
            });
    }

    getUsersForCompany(companyId: string): Observable<{} | User> {
        let url = `${this.adminUrl}Company/${companyId}/Users`;
        return this.http.get(url)
            .map((result: any) => {
                let json = result;
                if (json) {
                    return json.map((uJson: any) => new User(uJson));
                }
            })
            .catch((error: any) => {
                throw error;
            });
    }

    createUser(user: Partial<User>, companyId: string): Observable<{} | boolean> {
        let url = `${this.adminUrl}Company/${companyId}/Users`;
        return this.http.post(url, JSON.stringify(user), { headers: this.jsonHeader })
            .map((result: any) => {
                return true;
            }).catch((error: any) => {
                throw error;
            });
    }

    updateUser(user: User): Observable<{} | boolean> {
        let url = `${this.adminUrl}Company/${user.companyId}/Users/${user.id}`;
        let roles = {
            name: user.name,
            roles: user.roles
        };
        return this.http.put(url, JSON.stringify(roles), { headers: this.jsonHeader })
            .map((result: any) => {
                return true;
            })
            .catch((error: any) => {
                throw error;
            });
    }

    deleteUser(companyId: string, userId: string): Observable<{} | boolean> {
        let url = `${this.adminUrl}Company/${companyId}/Users/${userId}`;

        return this.http.delete(url, { headers: this.jsonHeader })
            .map((result: any) => {
                return true;
            })
            .catch((error: any) => {
                throw error;
            });
    }

    getImpersonationToken(userId: string, companyId: string): Observable<{} | any> {
        let url = `${this.adminUrl}Admin/Company/${companyId}/User/${userId}/Impersonate`;
        return this.http.get(url)
            .map((result: any) => {
                return result;
            })
            .catch((error: any) => {
                throw error;
            });
    }

    getCurrentUserInfo(): Observable<{} | User> {
      return this.http.get(`${this.adminUrl}User/`)
        .map((result: any) => {
          if (result) {
            return new User(result);
          }
        })
        .catch((error: any) => {
          throw error;
        });
    }

    updateUsername(userName: string): Observable<{} | boolean[]> {
        let url = this.adminUrl + 'User/' + userName;
        return this.http.put(url, undefined, { headers: this.jsonHeader })
            .map(() => {
                // This endpoint does not return any data. So if the request was succesfull return true
                return true;
            })
            .catch((error: any) => {
                throw error;
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/admin/admin.api.service.ts